import { proposal } from "../../globalState";

export function updateSumCosts(columns) {
  const prices = columns.reduce(
    (acc, items) => {
      const prices = items.reduce(
        (acc, item) => {
          const amount = item.countInUnit;
          return {
            TULUPrice: acc.TULUPrice + item.tulu_price * amount || 0,
            RetailPrice: acc.RetailPrice + item.retail_price * amount || 0,
          };
        },
        { TULUPrice: 0, RetailPrice: 0 }
      );

      return {
        TULUPrice: acc.TULUPrice + prices.TULUPrice || 0,
        RetailPrice: acc.RetailPrice + prices.RetailPrice || 0,
      };
    },
    { TULUPrice: 0, RetailPrice: 0 }
  );
  proposal.tuluPay = prices.TULUPrice;
  proposal.totalRetailCost = prices.RetailPrice;
}
